export enum JobTypeEnum {
  liveLoad = 'Live Load',
  preLoad = 'Pre-Load',
  traction = 'Traction',
}
